import React from "react";
import FactAndButtons from "./FactAndButtons";
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../main.css";

function SingleResult({ fillData }) {

  return (
    <div>
      {/* // <Alert className="mt-3 d-flex justify-content-center" bg="light"> */}
      <Alert className="pb-0 brdr-rg-green">
        <Alert.Heading className="pb-0">
          <Row className="pb-0">
            <Col className="text-center">
              <h3 className="pb-0">Tire Size: {fillData.tireSize}</h3>
            </Col>
          </Row>{" "}
          <hr className="hr-rg-green pt-0 mt-0" />
          <Row>
            <Col className="text-center">
              {Math.round(fillData.USGals)} US Gallons/Tire
            </Col>
            <Col className="text-center">
              {Math.round(fillData.liters)} Liters/Tire
            </Col>
            <Col className="text-center">
              {Math.round(fillData.impGals)} Imperial Gallons/Tire
            </Col>
          </Row>{" "}
          <Row className="pt-4">
            <Col className="text-center">
              Adding the suggested amount will add{" "}
              <strong>
                {Math.round(fillData.lbs)} lbs/{Math.round(fillData.kgs)} kgs{" "}
              </strong>
              of weight per tire and fill your tire 75% full
            </Col>
          </Row>
          {/* </Alert.Heading>
        </Alert> */}
        </Alert.Heading>
        <hr className="hr-rg-green" />
        <FactAndButtons />
      </Alert>
    </div>
  );
}

export default SingleResult;
